// extracted by mini-css-extract-plugin
var _1 = "KzEoh";
var _2 = "FO6uH";
export { _1 as "base", _2 as "isEditable" }
